import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Statistic, Typography } from "antd";
import {
  TeamOutlined,
  HeartFilled,
  CrownOutlined,
  DollarOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { formatCurrency, formatNumber } from "../../Utils/formatters";
import "./StatsCards.css";

const { Text } = Typography;

function StatsCards({ data }) {
  const navigate = useNavigate();

  const {
    totalUsers = 0,
    totalMatches = 0,
    premiumMembers = 0,
    totalRevenue = 0,
    pendingWithdrawals = 0,
    pendingWithdrawalsCount = 0,
  } = data || {};

  const cards = [
    {
      key: "users",
      variant: "blue",
      icon: <TeamOutlined />,
      title: "Total Users",
      value: formatNumber(totalUsers),
      change: 12,
      changeType: "up",
      onClick: () => navigate("/admin/users"),
    },
    {
      key: "matches",
      variant: "red",
      icon: <HeartFilled />,
      title: "Total Matches",
      value: formatNumber(totalMatches),
      change: 8,
      changeType: "up",
      onClick: () => navigate("/admin/users"),
    },
    {
      key: "premium",
      variant: "yellow",
      icon: <CrownOutlined />,
      title: "Premium Members",
      value: formatNumber(premiumMembers),
      change: 15,
      changeType: "up",
      onClick: () => navigate("/premium-members"),
    },
    {
      key: "revenue",
      variant: "green",
      icon: <DollarOutlined />,
      title: "Total Revenue",
      value: formatCurrency(totalRevenue),
      change: 25,
      changeType: "up",
      onClick: () => navigate("/admin/transactions"),
    },
    {
      key: "withdrawals",
      variant: "pink",
      icon: <WalletOutlined />,
      title: "Pending W.",
      value: formatCurrency(pendingWithdrawals),
      change: pendingWithdrawalsCount,
      changeType: "down",
      changeLabel: "pending",
      onClick: () => navigate("/admin/withdrawals"),
    },
  ];

  return (
    <div className="stats-cards-section">
      <Row gutter={[12, 12]}>
        {cards.map((card, index) => (
          <Col
            key={card.key}
            xs={24}
            sm={12}
            md={8}
            lg={{ span: 21 / 5 }}
            xl={{ span: 21 / 5 }}
            xxl={{ span: 21 / 5 }}
          >
            <Card
              className={`stats-antd-card ${card.variant}`}
              onClick={card.onClick}
              hoverable
              bordered={false}
              style={{ animationDelay: `${index * 0.06}s` }}
            >
              {/* Compact Horizontal Layout */}
              <div className="stats-card-header">
                {/* Icon Box */}
                <div className="stats-card-icon">{card.icon}</div>

                {/* Right Side - Title + Value + Change */}
                <div className="stats-card-content">
                  <Text className="stats-card-title">{card.title}</Text>

                  {/* Value */}
                  <div className="stats-card-value">
                    <Statistic
                      value={card.value}
                      valueStyle={{
                        fontSize: 20,
                        fontWeight: 800,
                        color: "#0f172a",
                        lineHeight: 1,
                      }}
                    />
                  </div>

                  {/* Change Badge */}
                  {card.change !== undefined && card.change !== 0 && (
                    <div
                      className={`stats-card-change ${card.changeType === "down" ? "down" : "up"
                        }`}
                    >
                      {card.changeType === "up" ? "↗" : "↘"} {card.change}
                      {card.changeLabel ? ` ${card.changeLabel}` : "%"}
                    </div>
                  )}
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default StatsCards;